export const VISTA_VENDEDOR_GET_COUNTERS_BEGIN = "VISTA_VENDEDOR_GET_COUNTERS_BEGIN"
export const  VISTA_VENDEDOR_GET_COUNTERS_SUCCESS = "VISTA_VENDEDOR_GET_COUNTERS_SUCCESS"
export const VISTA_VENDEDOR_GET_COUNTERS_FAILURE = "VISTA_VENDEDOR_GET_COUNTERS_FAILURE"
export const VISTA_VENDEDOR_MARK_CATALOG_FORCE_REFRESH = "VISTA_VENDEDOR_MARK_CATALOG_FORCE_REFRESH"
export const VISTA_VENDEDOR_CLEAR_CATALOG_FORCE_REFRESH = "VISTA_VENDEDOR_CLEAR_CATALOG_FORCE_REFRESH"